export function transformBrand(codeVendeur: string): string {
  switch (codeVendeur.toUpperCase()) {
    case 'VYV':
      return 'VY';
    case 'HM':
      return 'HM';
    case 'MGEN':
      return 'MG';
    case 'MNT':
      return 'MT';
    default:
      return codeVendeur.toUpperCase();
  }
}

export interface Brand {
  code: string;
  label: string;
}

export const HmBrand = 'HM';
export const MgenBrand = 'MG';
export const MntBrand = 'MT';
export const VyvBrand = 'VY';

const brands = [
  { code: 'VYV', label: 'VYV Conseil' },
  { code: HmBrand, label: 'Harmonie Mutuelle' },
  { code: 'MGEN', label: 'MGEN' },
  { code: 'MNT', label: 'MNT' },
];

export function getBrandLabel(code: string): string {
  const brand = brands.find((b) => b.code === code);
  return brand ? brand.label : code;
}

export function isPartner(brand: any): boolean {
  if (!brand) return false;
  let brandNormalise = transformBrand(brand);
  return brandNormalise === HmBrand || brandNormalise === MgenBrand || brandNormalise === MntBrand;
}
